import React from "react";
import styles from "./HeaderFormsComponent.module.css";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import { useTranslation } from "react-i18next";

const HeaderFormsComponent = ({
  icon,
  action,
  emailConnections = [],
  selectedEmailConnection,
  setSelectedEmailConnection = () => {},
  placeholder ,
  headerStyle = {},
  emailConnectionsId = [],
  handleConfigurationChange,
  CustomDropdownOptionStyles,
  type,
  setIsOpenAutomate,
  isOpenAutomate,
  setToggleChatSettings,
  toggleChatSettings
}) => {
  const {t} = useTranslation('Preview')


  return (
    <div className={styles.header} style={headerStyle}>
      <div className={styles.headerMail}>
        <div className={styles.iconContainer}>{icon}</div>
        <CustomDropdown
          options={emailConnections}
          isEmail={true}
          height="27px"
          borderRadius="0px 8px 8px 0px"
          placeholder={placeholder ||  t('addAnEmailAccount')}
          selectedOption={selectedEmailConnection}
          setSelectedOption={setSelectedEmailConnection}
          emailsDropdown={true}
          emailConnectionsId={emailConnectionsId}
          fromHeader={true}
          handleConfigurationChange={handleConfigurationChange}
          customStylesOptions={CustomDropdownOptionStyles}
          type={type}
        />
      </div>
      <div className={styles.addConnection} >
      <p onClick={() => setToggleChatSettings((prev) => 
        prev === 'setting' ? 'chat' : 'setting'
      )}>
        {toggleChatSettings === 'setting' ? 'setting' : 'chat'}
      </p>
      {/* <p className={isOpenAutomate ? styles.active : ''} onClick={() => setIsOpenAutomate(prev => !prev)}>
        Ver stats
      </p> */}
      {<p className={styles.active} onClick={() => type !== "XML" && action()}>
        {type !== "XML" ? t('addConnection') : ""}
      </p>}
      </div>
        
    </div>
  );
};

export default HeaderFormsComponent;
